import { render, staticRenderFns } from "./ContratoModalAgregar.vue?vue&type=template&id=9452a222&"
import script from "./ContratoModalAgregar.vue?vue&type=script&lang=ts&"
export * from "./ContratoModalAgregar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports